let contractTypes = [
  {
    handle: 0,
    name: 'All'
  },
  {
    handle: 1,
    name: 'Fixed price 6 months'
  },
  {
    handle: 2,
    name: 'Fixed price 1 year'
  },
  {
    handle: 4,
    name: 'Fixed price 2 years'
  },
  {
    handle: 5,
    name: 'Fixed price 3 years'
  },
  {
    handle: 6,
    name: 'Fixed price 4 years'
  },
  {
    handle: 7,
    name: 'Fixed price 5 years'
  },
  {
    handle: 9,
    name: 'Floating 1 year'
  },
  {
    handle: 10,
    name: 'Floating price ongoing'
  },
  {
    handle: 13,
    name: 'Mixed contract 1 year'
  }
]

export {contractTypes}



// WEBPACK FOOTER //
// ./resources/assets/js/app/services/data/contractTypes.js